import React, { useEffect, useRef, useState } from 'react'

const QRCodeDisplay = ({
  value,
  expanded,
  smallSize = 100,
  largeSize = 220
}) => {
  const qrCodeRef = useRef(null)

  useEffect(() => {
    if (!value || !qrCodeRef.current) return

    if (!window.QRCode) {
      console.error('Biblioteca QRCode.js não foi carregada.')
      return
    }

    qrCodeRef.current.innerHTML = ''

    const size = expanded ? largeSize : smallSize

    new window.QRCode(qrCodeRef.current, {
      text: String(value),
      width: size,
      height: size,
      correctLevel: window.QRCode.CorrectLevel.H
    })

    return () => {
      if (qrCodeRef.current) {
        qrCodeRef.current.innerHTML = ''
      }
    }
  }, [value, expanded, smallSize, largeSize])

  return (
    <div
      ref={qrCodeRef}
      className="d-flex justify-content-center align-items-center"
      style={{
        minHeight: expanded ? largeSize : smallSize
      }}
    />
  )
}

const CardContextExpansive = ({ data = [], isRenderModal = false, enableQRCode = false }) => {

  const [expanded, setExpanded] = useState(false)

  if (data.length === 0) return <></>;

  return (
    <div className={"card-context-dynamic-wrapper d-flex flex-column cb-variant-bordered"}>
      <div
        className={`card-context-dynamic ${isRenderModal ? 'p-3' : 'p-4'}`}
      >
        <div className='row'>
          {Array.isArray(data[0]) && data[0].length > 0 && (
            <div
              className={`${enableQRCode
                  ? 'col-md-3 col-12'
                  : 'col-md-5 col-12'
                } border-2 border-end border-color-cinza2 pe-5`}
            >
              <div className='row'>
                {data[0]?.slice(0, 4).map((item, index) => {

                  const exibirQRCode = enableQRCode && item.qrcode;

                  return (
                    <div
                      key={index}
                      className={`d-flex flex-column mb-3 ${exibirQRCode
                        ? 'align-items-center justify-content-center col-12'
                        : item.largura
                        }`}
                    >
                      {exibirQRCode ? (
                        <QRCodeDisplay
                          value={item.qrcode}
                          expanded={expanded}
                          smallSize={100}
                          largeSize={220}
                        />
                      ) : (
                        <>
                          <span className="font-size-14 font-w-500 mb-1 text-color-cinza5 flex-wrap">
                            {item.titulo}
                          </span>

                          <span className="font-size-14 font-w-600 text-color-cinza5 flex-wrap">
                            {item.valor}
                          </span>
                        </>
                      )}
                    </div>
                  );
                })}
              </div>
              {expanded && (
                <div className='row mt-4'>
                  {data[0]?.slice(4, 99).map((item, index) => {

                    return (
                      <div
                        key={index}
                        className={`d-flex flex-column mb-3 ${item.largura}`}
                      >
                        <span className={`font-size-14 font-w-500 mb-1 text-color-cinza5 flex-wrap`}>
                          {item.titulo}
                        </span>
                        <span className=" font-size-14 font-w-600 text-color-cinza5 flex-wrap">
                          {item.valor}
                        </span>
                      </div>
                    )
                  })}
                </div>
              )}
            </div>
          )}
          <div
            className={
              Array.isArray(data[0]) && data[0].length > 0
                ? enableQRCode
                  ? 'col-md-8 col-12 ps-5'
                  : 'col ps-5'
                : 'col'
            }
          >
            <div className='row'>
              {data[1] && data[1]?.map((item, index) => {
                return (
                  <div
                    key={index}
                    className={`d-flex flex-column mb-3 ${item.largura}`}
                  >
                    {item.titulo && (
                      <span className={`font-size-16 font-w-600 mb-1 text-color-azul1 flex-wrap`}>
                        {item.titulo}
                      </span>
                    )}
                    {item.subtitulo && (
                      <span className="font-size-14 font-w-600 mb-1 text-color-cinza5 flex-wrap">
                        {item.subtitulo}
                      </span>
                    )}
                    {!!item.descricao && expanded && (
                      <span className=" font-size-12 text-color-cinza5 flex-wrap">
                        {item.descricao}
                      </span>
                    )}
                    {item?.html && !!item?.html && expanded && (
                      <div dangerouslySetInnerHTML={{ __html: item?.html || "" }} />
                    )}
                  </div>
                )
              })}
            </div>
          </div>
          <div style={{ width: 70 }} className='col-1 d-flex align-items-center justify-content-center'>
            <button
              type="button"
              className="btn bg-transparent border-0 no-print"
              onClick={() => setExpanded(!expanded)}
            >
              <i className={`fa-solid fa-chevron-${expanded ? "up" : "down"} text-color-azul1`}></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CardContextExpansive